import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import cfg from '../../public/static/cfg'

Vue.use(VueRouter)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const welcome = () => import('@/components/welcome')
const layout = () => import('@/components/layout')
const error = () => import('@/components/err')
const appoint = () => import('@/components/appoint/index')
const patient = () => import('@/components/patient/index')
const pool = () => import('@/components/pool/index')
const type = () => import('@/components/type/index')
const channel = () => import('@/components/channel/index')
const registry = () => import('@/components/registry/index')
const triage = () => import('@/components/triage/index')
const regInvoice = () => import('@/components/invoice/index')
const charge = () => import('@/components/fee/index')
const settle = () => import('@/components/settle/index')
const precheck = () => import('@/components/precheck/index')
const statistics = () => import('@/components/statistics/index')
const callback = ()=> import('@/components/callback/index')
const npOrder = () => import('@/components/npOrder/index')
const medcom = () => import('@/components/_medcom/index')

const routes = [
  {
    path: '/err',
    name: 'err',
    component: error
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: welcome,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/',
    name: 'index',
    component: layout,
    redirect: { name: 'leisure' },
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: '/leisure',
        name: 'leisure',
        component: () => import('@/components/leisure'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/reg',
        name: 'reg',
        component: registry,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/app',
        name: 'app',
        component: appoint,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/patient',
        name: 'patient',
        component: patient,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/pool',
        name: 'pool',
        component: pool,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/type',
        name: 'type',
        component: type,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/channel',
        name: 'channel',
        component: channel,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/triage',
        name: 'triage',
        component: triage,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/invoice',
        name: 'invoice',
        component: regInvoice,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/charge',
        name: 'charge',
        component: charge,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/settle',
        name: 'settle',
        component: settle,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/precheck',
        name: 'precheck',
        component: precheck,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/statistics',
        name: 'statistics',
        component: statistics,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/callback',
        name: 'callback',
        component: callback,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/npOrder',
        name: 'npOrder',
        component: npOrder,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/log',
        name: 'log',
        component: () => import('@/components/log/index'),
        meta: {
          requireAuth: true
        }
      },
    // TODO 测试用页面，正式使用需删除该路径
      {
        path: '/medcom',
        name: 'medcom',
        component: medcom,
        meta: {
          requireAuth: true
        }
      },
    ]
  }
]

// -R202212
function hisFn() {
  if (process.env.NODE_ENV !== 'development') {
    const STORAGE = 'registrationVersion';
    const node = document.querySelector('#rick');
    if (node) document.head.removeChild(node);
    let timer = setTimeout(() => {
      clearTimeout(timer);
      timer = null;
      const el = document.createElement('script');
      el.src = `versionIdentification.js?v=${new Date().getTime()}`;
      el.id = 'rick';
      el.onload = function () {
        const old = localStorage.getItem(STORAGE);
        const { versionIdentification: v } = window;
        if (v && old && v !== old) {
          localStorage.setItem(STORAGE, v);
          window.location.reload();
        }
        if (!old) localStorage.setItem(STORAGE, v);
      }
      document.head.appendChild(el);
    });
  }
}
const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  hisFn();
  if (to.matched.some(r => r.meta.requiresAuth)) {
    if (store.getters.token) {
      next()
    } else {
      next({ name: 'welcome' })
    }
  } else {
    if (to.matched.some(r => r)) {
      next()
    } else {
      next({
        name: 'err',
        params: { err: cfg.errs.NoPath }
      })
    }
  }
})

export default router
